import React, { useEffect, useState } from "react";
import { IClient } from "../../pages/Clients";
import { Page } from "./styles";

const ClientChart = ({name, messageCount, messageLimit}: IClient) => {
  const [percentage, setPercentage] = useState(0);
  useEffect(() => {
    if(messageLimit)
    setPercentage(Math.ceil((messageCount / messageLimit) * 100));
  }, [messageCount, messageLimit]);
  return (
    <Page>
      <div className="info">
        {name}
        <span>{messageCount}/{messageLimit}</span>
      </div>
      <div className="single-chart">
        <svg viewBox="0 0 36 36" className="circular-chart green">
          <path
            className="circle-bg"
            d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            className="circle"
            stroke-dasharray={`${percentage},100`}
            d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <text x="18" y="20.35" className="percentage">
           {percentage}%
          </text>
        </svg>
      </div>
    </Page>
  );
};
export { ClientChart };
